import { render, staticRenderFns } from "./DettaglioSocio.vue?vue&type=template&id=09961bea&"
import script from "./DettaglioSocio.vue?vue&type=script&lang=js&"
export * from "./DettaglioSocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports